module.exports = __webpack_public_path__ + "img/left_arrow.290174b6.svg";